import { Chip } from '@mui/material'
import FailStatusIcon from '@mui/icons-material/HighlightOffOutlined'
import { BenchmarkStatusChip, BenchmarkStatusModalStateDialogActions } from '../BenchmarkStatus'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'

import { Benchmark, FieldModel } from '@cibo/core'

export interface FieldProgramRecommendationColumnProps {
  benchmark: Benchmark
  programId: string
  t: TFunction
  DialogActions?: BenchmarkStatusModalStateDialogActions
}

export const fieldProgramRecommendationColumn = ({
  benchmark,
  programId,
  t,
  DialogActions,
}: FieldProgramRecommendationColumnProps) => ({
  field: 'recommendationScore',
  headerName: t('recommendation'),
  flex: 1,
  minWidth: 200,
  renderCell: (params: GridRenderCellParams<number, FieldModel>) => {
    if (params.row.hasLedgerConfict(programId)) {
      return (
        <Chip
          size="small"
          color="error"
          icon={<FailStatusIcon />}
          label={t('status', { context: 'disallowed' })}
        />
      )
    }

    return (
      <BenchmarkStatusChip
        fieldModel={params.row}
        programId={programId}
        benchmark={benchmark}
        DialogActions={DialogActions}
      />
    )
  },
})
